"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERRAL_TERMS_EL = void 0;
exports.REFERRAL_TERMS_EL = `## Πρόγραμμα επιβράβευσης (σύσταση / referral)

- Μοιραστείτε τον προσωπικό σας σύνδεσμο ή κωδικό εγγραφής.
- Όταν ένας νέος χρήστης εγγραφεί μέσω σας και ολοκληρώσει την **πρώτη επιτυχή πληρωμή** συνδρομής, κερδίζετε **12€ referral credit** (ισοδύναμο 1 μήνα Basic).
- Η ανταμοιβή χορηγείται **μία φορά ανά προσκεκλημένο** χρήστη.
- Για να λάβετε credit, πρέπει να είστε **ενεργός συνδρομητής PRO** (μη ληγμένη συνδρομή) **τη στιγμή** της πρώτης πληρωμής του προσκεκλημένου.
- Το credit συσσωρεύεται σε ένα υπόλοιπο και εφαρμόζεται στο checkout συνδρομής (μερική ή πλήρης κάλυψη).
- Δεν ισχύει για δωρεάν αναβαθμίσεις από admin ή δοκιμαστικές χορηγήσεις χωρίς πληρωμή.
- Η ProfferAI μπορεί να τροποποιήσει ή να διακόψει το πρόγραμμα με εύλογη ειδοποίηση.`;
